module.exports = __webpack_public_path__ + "static/media/no.42211195.png";